import _defineProperty2 from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './Date.css';
import React, { useState, useRef, useEffect } from 'react';
import Flatpickr from 'react-flatpickr';
import { format, formatDistanceToNowStrict } from 'date-fns';
// import "flatpickr/dist/themes/material_green.css";
import { IconDate } from '../../../../../atoms/Icons/';
import { SitecoreContextReactContext } from '../../../../../../utils/SitecoreContextReactContext';
import { get } from '../../../../../../utils';
import { commonStyles as dateStyles } from '../../../../../Listing/DateRange';
import { Arabic } from 'flatpickr/dist/l10n/ar.js';
import { Russian } from 'flatpickr/dist/l10n/ru.js';
import { Czech } from 'flatpickr/dist/l10n/cs.js';
import { Dutch } from 'flatpickr/dist/l10n/nl.js';
import { Finnish } from 'flatpickr/dist/l10n/fi.js';
import { German } from 'flatpickr/dist/l10n/de.js';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';
import { Norwegian } from 'flatpickr/dist/l10n/no.js';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import { Swedish } from 'flatpickr/dist/l10n/sv.js';
import { Mandarin } from 'flatpickr/dist/l10n/zh.js';
import { Danish } from 'flatpickr/dist/l10n/da.js';
import { French } from 'flatpickr/dist/l10n/fr.js';
import { Italian } from 'flatpickr/dist/l10n/it.js';
import { Korean } from 'flatpickr/dist/l10n/ko.js';
import { Polish } from 'flatpickr/dist/l10n/pl.js';
import { Romanian } from 'flatpickr/dist/l10n/ro.js';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import { Ukrainian } from 'flatpickr/dist/l10n/uk.js';
var DateField = function DateField(props) {
  var label = props.label,
    _props$name = props.name,
    name = _props$name === void 0 ? 'name' : _props$name,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    _props$dateFormat = props.dateFormat,
    dateFormat = _props$dateFormat === void 0 ? 'yyyy-mm-dd' : _props$dateFormat,
    updateContext = props.updateContext,
    _props$patternInvalid = props.patternInvalidMessage,
    patternInvalidMessage = _props$patternInvalid === void 0 ? 'validateError' : _props$patternInvalid,
    _props$validate = props.validate,
    validate = _props$validate === void 0 ? false : _props$validate,
    contextValue = props.value,
    blurEvent = props.blurEvent,
    isOnlyFuture = props.isOnlyFuture,
    isOnlyPast = props.isOnlyPast,
    ageLimit = props.ageLimit;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    highLightText = _useState4[0],
    setHighLightText = _useState4[1];
  var clickedTextRef = useRef(false);
  var currentLang = get(sitecoreContext, 'language');
  var currentLocale = function currentLocale(lang) {
    if (lang === 'ar') {
      return Arabic;
    }
    if (lang === 'ru') {
      return Russian;
    }
    if (lang === 'cs') {
      return Czech;
    }
    if (lang === 'nl') {
      return Dutch;
    }
    if (lang === 'fi') {
      return Finnish;
    }
    if (lang === 'de') {
      return German;
    }
    if (lang === 'ja') {
      return Japanese;
    }
    if (lang === 'no') {
      return Norwegian;
    }
    if (lang === 'pt') {
      return Portuguese;
    }
    if (lang === 'sv') {
      return Swedish;
    }
    if (lang === 'zh') {
      return Mandarin;
    }
    if (lang === 'da') {
      return Danish;
    }
    if (lang === 'fr') {
      return French;
    }
    if (lang === 'it') {
      return Italian;
    }
    if (lang === 'ko') {
      return Korean;
    }
    if (lang === 'pl') {
      return Polish;
    }
    if (lang === 'ro') {
      return Romanian;
    }
    if (lang === 'es') {
      return Spanish;
    }
    if (lang === 'uk') {
      return Ukrainian;
    }
  };
  var onChangeEvent = function onChangeEvent(value) {
    updateContext(_defineProperty2({}, name, _objectSpread(_objectSpread({}, props), {}, {
      valid: required && !inValid,
      value: value,
      ageInvalid: checkAgeLimitInvalid(value)
    })));
  };
  var flatPickerDateFormat = '';
  if (dateFormat.toLowerCase() === 'yyyy-mm-dd') {
    flatPickerDateFormat = 'yy-m-d';
  } else if (dateFormat.toLowerCase() === 'dd-mm-yyyy') {
    flatPickerDateFormat = 'd-m-yy';
  } else if (dateFormat.toLowerCase() === 'dd/mm/yyyy') {
    flatPickerDateFormat = 'd/m/yy';
  } else if (dateFormat.toLowerCase() === 'yyyy/mm/dd') {
    flatPickerDateFormat = 'yy/m/d';
  }
  var _React$useState = React.useState(contextValue),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    state = _React$useState2[0],
    setstate = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    open = _React$useState4[0],
    setOpen = _React$useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    inValid = _useState6[0],
    setInValid = _useState6[1];
  var fp = /*#__PURE__*/React.createRef();
  useEffect(function () {
    document.body.addEventListener('click', function () {
      if (!clickedTextRef.current) {
        setHighLightText(false);
      }
      setOpen(false);
    });
    if (fp.current) {
      var flatPickerDiv = get(fp, 'current.flatpickr.calendarContainer');
      flatPickerDiv.addEventListener('click', function (e) {
        e.stopPropagation();
        // setOpen(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    if (validate) required && setInValid(!(contextValue && contextValue.length));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validate]);
  useEffect(function () {
    if (contextValue && contextValue.length) {
      var currentDate = new Date(contextValue.replaceAll('-', '/'));
      if (isNaN(currentDate)) return;
      var validFormat = format(currentDate, 'yyyy-MM-dd');
      setstate(validFormat);
      updateContext(_defineProperty2({}, name, _objectSpread(_objectSpread({}, props), {}, {
        valid: required && !inValid,
        value: validFormat,
        ageInvalid: checkAgeLimitInvalid(validFormat)
      })));
    } else {
      setValue('');
      setstate('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contextValue]);
  /* change format to flatpicker format as standard format not supported */
  var formatDate = function formatDate(_ref, dateStr) {
    var _ref2 = _slicedToArray(_ref, 1),
      date = _ref2[0];
    var selectedDate = new Date(Array.isArray(date) ? date[0] : date || dateStr);
    var day = selectedDate.getDate();
    var year = selectedDate.getFullYear();
    var month = selectedDate.getMonth() + 1;
    var ds = "".concat(year, "-").concat(month, "-").concat(day);
    setOpen(false);
    setstate(ds);
    setInValid(false);
    onChangeEvent(ds);
  };
  var handleTextMousedown = function handleTextMousedown() {
    clickedTextRef.current = true;
  };
  var handleTextFocus = function handleTextFocus() {
    if (!clickedTextRef.current) {
      setHighLightText(true);
    }
  };
  var handleTextBlur = function handleTextBlur() {
    clickedTextRef.current = false;
    if (blurEvent) blurEvent(state);
    if (!open) {
      setHighLightText(false);
    }
  };
  var checkAgeLimitInvalid = function checkAgeLimitInvalid(date) {
    try {
      // Replace dashes with slashes for better cross-browser compatibility
      var normalizedDate = date.replaceAll('-', '/');
      var distance = formatDistanceToNowStrict(new Date(normalizedDate));
      // util returns distance in next formats: '1 day', '1 month', '1 year', '5 years', etc
      var ageState = distance.includes('year') ? parseFloat(distance) < Number(ageLimit) : true;
      if (!ageLimit) {
        return false;
      } else {
        setInValid(ageState);
        return ageState;
      }
    } catch (error) {
      console.error('Error in checkAgeLimitInvalid:', error);
      setInValid(true);
      return true;
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(rtl ? rtlStyles : ltrStyles, " ").concat(styles, " ").concat(dateStyles, "  wiz__form-group ")
  }, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", {
    className: "accessibility-hidden-text"
  }, label), label && /*#__PURE__*/React.createElement("label", {
    className: "body-small wiz__label",
    htmlFor: name
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "date-field",
    onMouseDown: handleTextMousedown,
    onFocus: handleTextFocus,
    onBlur: handleTextBlur,
    onClick: function onClick() {
      setOpen(true);
    }
  }, /*#__PURE__*/React.createElement("input", {
    name: name,
    type: "text",
    className: "\n                  flatpickr-input\n                  ".concat(open ? 'flatpickr-input--openedDrop' : '', "\n                  ").concat(highLightText ? 'input-text-primary--focused' : '', "\n                  ").concat(inValid ? ' invalid-field' : '', "\n                "),
    value: state,
    readOnly: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(open ? '' : 'd-none', " datepicker")
  }, /*#__PURE__*/React.createElement(Flatpickr, {
    ref: fp,
    options: {
      dateFormat: flatPickerDateFormat,
      inline: true,
      locale: currentLang === 'en' ? 'en' : currentLocale(currentLang),
      minDate: isOnlyFuture ? 'today' : undefined,
      maxDate: isOnlyPast ? 'today' : undefined
    },
    "aria-label": label,
    value: value,
    onChange: formatDate
  })), /*#__PURE__*/React.createElement("span", {
    className: "date-field__icon"
  }, /*#__PURE__*/React.createElement(IconDate, null))), inValid && /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("p", {
    className: "text-input__error text__error"
  }, patternInvalidMessage))));
};
var styles = "s1izndbu";
var ltrStyles = "l48kox9";
var rtlStyles = "r5vme8b";
export default DateField;